module.exports = __webpack_public_path__ + "img/leftList0.40fc2808.svg";